import { BigBashEvent } from "@/types/types";
import SmallHelpers from "@/utils/SmallHelpers";
import GameResultsCalculator from "./GameResultsCalculator";

class ScoreCalculator {
	private smallHelpers = new SmallHelpers();
	private gameResultsCalculator = new GameResultsCalculator();

	/**
	 * Calculate the total placement points across all games.
	 */
	public calculateScores(event: BigBashEvent): Map<string, number> {
		const playedGames = this.smallHelpers.getPlayedGames(event);
		const totalPoints = new Map<string, number>();

		playedGames.forEach(gameId => {
			const game = this.smallHelpers.getGameByGameId(event, gameId);
			if (game) {
				// Use getRankedGameResults for total score calculation
				const gameResults = this.gameResultsCalculator.getRankedGameResults(game, event);
				gameResults.forEach((points, teamId) => {
					totalPoints.set(teamId, (totalPoints.get(teamId) ?? 0) + points);
				});
			}
		});

		return totalPoints;
	}
}

export default ScoreCalculator;